import { DEPRECIATION_METHOD_CODE } from 'common/constants'
import { findAccountingLedger } from 'common/helpers'
import { isEqual } from 'lodash'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectorLedgerSettingsList } from 'store/settings/ledgerSetting/selectors'

import { useGetAssetLedger } from './use-get-asset-ledger'

export const useSupportPartialImpairment = () => {
  const { data: ledgerSettings } = useSelector(selectorLedgerSettingsList, isEqual)
  const accountingLedger = useMemo(() => findAccountingLedger(ledgerSettings), [ledgerSettings])
  const assetAccountingLedger = useGetAssetLedger(accountingLedger)

  return Boolean(
    assetAccountingLedger?.depreciation_method_code &&
      ![
        DEPRECIATION_METHOD_CODE.AVERAGE_USAGE_PERIOD,
        DEPRECIATION_METHOD_CODE.LEASE_PERIOD_STRAIGHT_LINE,
        DEPRECIATION_METHOD_CODE.NON_DEPRECIABLE,
      ].includes(assetAccountingLedger.depreciation_method_code)
  )
}
